<template>
  <v-menu
    :min-width="menuWidth"
    :max-width="menuWidth"
    :disabled="$store.state.isWorkflowDisabled"
    scrim="true"
  >
    <template #activator="{ props }">
      <slot name="activator" :props="props">
        <v-avatar class="color-item" :color="color || 'rgb(238,238,238)'" v-bind="props" size="16"></v-avatar>
      </slot>
    </template>

    <div class="color-picker">
      <div :class="{'pa-1': appearance === 'diagram'}">
        <v-row class="flex-wrap justify-lg-space-between ma-1">
          <v-col
            cols="3"
            v-for="colorOption in colorOptions"
            :class="{
              'text-center': true,
              'pa-1': true,
              'mt-1': appearance !== 'diagram',
              'mb-1': appearance !== 'diagram'
            }"
            :key="computeRGBString(colorOption)"
          >
            <v-avatar
              class="color-item"
              :size="avatarSize"
              :color="computeRGBString(colorOption)"
              @click="$emit('change', colorOption)"
            >
              <v-icon size="small" :color="getForegroundColor(colorOption)" v-if="color === computeRGBString(colorOption)">mds:check</v-icon>
            </v-avatar>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </div>
    </div>
  </v-menu>
</template>

<script>
import { selectForegroundColor } from '@/utils/color'
import { CARD_COLORS, EVENT_COLORS, hexToRgb } from '@/shared/constants/colorPalette'

export default {
  props: {
    color: String,
    variant: String, // options: 'cards', 'events'
    appearance: String // 'diagram', 'regular' [default]
  },

  data () {
    return {
      colors: {
        cards: CARD_COLORS.map((c) => hexToRgb(c.light)),
        events: EVENT_COLORS.map((c) => hexToRgb(c.light))
      }
    }
  },

  computed: {
    colorOptions () {
      return this.colors[this.variant] || []
    },

    menuWidth () {
      return this.appearance === 'diagram' ? '100' : '160'
    },

    avatarSize () {
      return this.appearance === 'diagram' ? '16' : '24'
    }
  },

  methods: {
    getForegroundColor (color) {
      return selectForegroundColor(color.red, color.green, color.blue)
    },

    computeRGBString (color) {
      return `rgb(${color.red},${color.green},${color.blue})`
    }
  }
}
</script>

<style scoped>
  .color-picker {
    border-radius: 8px;
    background-color: var(--light-1);
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);
  }

  .color-item {
    cursor: pointer;
  }
</style>
